export const tokens = {
  rewardToken: {
    token: "XTOKEN",
    address: "0x7f3141c4d6b047fb930991b450f1ed996a51cb26",
    decimals: 18,
  },
};
